import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-courses',
  templateUrl: './home-courses.component.html',
  styleUrls: ['./home-courses.component.css']
})
export class HomeCoursesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
